(function(w, d) {
	w.createAnalyticsScripts = createAnalyticsScripts;

	function createAnalyticsScripts() {
		const scriptInline = d.createElement('script');
		const scriptExternal = d.createElement('script');
		const id = 'UA-76249469-1';

		d.head.prepend(scriptInline);
		scriptInline.innerHTML = `window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date; ga('create', '${id}', 'auto'); ga('send', 'pageview');`;
		d.head.prepend(scriptExternal);
		scriptExternal.type = 'text/javascript';
		scriptExternal.async = true;
		scriptExternal.src = 'https://www.google-analytics.com/analytics.js';
	}
})(window, document);
